define('utils/loader',['jquery'], function ($) {
	
	/**
	 * Loader indicator
	 * 
	 * useage
	 * var loader = new Loader();
	 * loader.get(); // get the element and add it somewhere
	 * loader.remove(); // remove from element where it is added
	 */
	var Loader = function () {
		this.element = $('<img class="loading" src="'+staticDomain+'/../../images/ajax-loader.gif" alt="Loading">');
		
		return this.element;
	};
	Loader.prototype.get = function () {
		return this.element;
	};
	Loader.prototype.remove = function () {
		this.element.detach();
	};
	
	return Loader;
	
});
